<template>
  <v-container>
    <Navbar
      :hasDrawer="true"
      title="Configurações"
    >
      <v-btn
        slot="actions"
        text
        @click="save"
      >Salvar</v-btn>
    </Navbar>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-alert
          v-if="error"
          dense
          outlined
          type="error"
        >
          <strong>{{ error }}</strong>
        </v-alert>
        <div class="d-flex justify-space-between align-center mb-3">
          <h5 class="text-uppercase">Servidor</h5>
          <v-btn
            small
            :color="btnTestColor"
            :loading="loading"
            @click="testServidor"
          >
            <v-icon small left v-if="testOk || testError">{{ btnTestIcon }}</v-icon>
            {{ btnTestText }}
          </v-btn>
        </div>
        <v-card>
          <v-card-text>
            <v-row>
              <!-- Host -->
              <v-col cols="12">
                <v-text-field
                  v-model="host"
                  type="url"
                  label="Host"
                  placeholder="Ex: http://meudominio.com/api"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <!-- SQL SAIDA -->
              <v-col cols="6">
                <v-text-field
                  v-model="sqlSaida"
                  label="SQL Saída"
                  placeholder="Código SQL"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <!-- SQL ITEM SAIDA -->
              <v-col cols="6">
                <v-text-field
                  v-model="sqlItemSaida"
                  label="SQL Item Saída"
                  placeholder="Código SQL"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <!-- SQL PRODUCAO -->
              <v-col cols="6">
                <v-text-field
                  v-model="sqlProducao"
                  label="SQL Produção"
                  placeholder="Código SQL"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <!-- SQL ITEM PRODUCAO -->
              <v-col cols="6">
                <v-text-field
                  v-model="sqlItemProducao"
                  label="SQL Item Produção"
                  placeholder="Código SQL"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <!-- SQL UNIDADES -->
              <v-col cols="6">
                <v-text-field
                  v-model="sqlUnidades"
                  label="SQL Unidades"
                  placeholder="Código SQL"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <!-- ID ESTOQUE ENTRADA PRODUÇÃO -->
              <v-col cols="6">
                <v-text-field
                  v-model="idEstoqueEntradaProducao"
                  label="Estoque Ent. Produção"
                  placeholder="ID Estoque Entrada Produção"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <!-- ID COLABORADOR -->
              <v-col cols="12">
                <v-text-field
                  v-model="idColaborador"
                  label="ID Colaborador"
                  placeholder="ID Colaborador"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- Codigo de Barras -->
      <v-col cols="12" class="pb-0">
        <h5 class="text-uppercase mb-3">Coleta</h5>
        <v-list class="py-0" elevation="1">
          <v-list-item
            class="pr-0"
            v-for="(config, i) of configuracoes"
            :key="i"
          >
            <v-list-item-content :class="i !== configuracoes.length -1 ? 'pb-0' : ''">
              <v-row no-gutters>
                <v-col cols="10" align-self="center">
                  {{ config.description }}
                </v-col>
                <v-col cols="2">
                  <v-switch hide-details class="ma-0" v-model="config.value"></v-switch>
                </v-col>
              </v-row>
              <v-divider class="mt-3" v-if="i !== configuracoes.length - 1" :key="i"></v-divider>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <!-- Layout -->
      <v-col cols="12" class="pb-0">
        <h5 class="text-uppercase mb-3">Layout</h5>
        <v-list class="py-0" elevation="1">
          <v-list-item
            class="pr-0"
            v-for="(config, i) of configLayout"
            :key="i"
          >
            <v-list-item-content :class="i !== configLayout.length -1 ? 'pb-0' : ''">
              <v-row no-gutters>
                <v-col cols="10" align-self="center">
                  {{ config.description }}
                </v-col>
                <v-col cols="2">
                  <v-switch hide-details class="ma-0" v-model="config.value"></v-switch>
                </v-col>
              </v-row>
              <v-divider class="mt-3" v-if="i !== configLayout.length - 1" :key="i"></v-divider>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <!-- Banco de Dados -->
      <v-col cols="12" class="pb-0">
        <h5 class="text-uppercase mb-3">Banco de Dados Local</h5>
        <v-card>
          <v-card-text>
            <v-btn
              block
              outlined
              color="error"
              @click="deleteDb"
            >Excluir</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import idbService from '@/services/idbService';
import { testApiV1Service } from '@/services/testApiV1Service';

export default {
  name: 'Configuracoes',
  data: () => ({
    testOk: false,
    testError: false,
    error: '',
    loading: false
  }),
  computed: {
    host: {
      get() {
        return this.$store.state.configuracoes.host;
      },
      set(value) {
        this.$store.dispatch('setHost', value);
      }
    },
    sqlSaida: {
      get() {
        return this.$store.state.configuracoes.sqlSaida;
      },
      set(value) {
        this.$store.dispatch('setSqlSaida', value);
      }
    },
    sqlItemSaida: {
      get() {
        return this.$store.state.configuracoes.sqlItemSaida;
      },
      set(value) {
        this.$store.dispatch('setSqlItemSaida', value);
      }
    },
    sqlUnidades: {
      get() {
        return this.$store.state.configuracoes.sqlUnidades;
      },
      set(value) {
        this.$store.dispatch('setSqlUnidades', value);
      }
    },
    sqlProducao: {
      get() {
        return this.$store.state.configuracoes.sqlProducao;
      },
      set(value) {
        this.$store.dispatch('setSqlProducao', value);
      }
    },
    sqlItemProducao: {
      get() {
        return this.$store.state.configuracoes.sqlItemProducao;
      },
      set(value) {
        this.$store.dispatch('setSqlItemProducao', value);
      }
    },
    idEstoqueEntradaProducao: {
      get() {
        return this.$store.state.configuracoes.idEstoqueEntradaProducao;
      },
      set(value) {
        this.$store.dispatch('setIdEstoqueEntradaProducao', value);
      }
    },
    idColaborador: {
      get() {
        return this.$store.state.configuracoes.idColaborador;
      },
      set(value) {
        this.$store.dispatch('setIdColaborador', value);
      }
    },
    configuracoes() {
      return this.$store.state.configuracoes.configuracoes;
    },
    configLayout() {
      return this.$store.state.configuracoes.configLayout;
    },
    btnTestText() {
      if (this.testError) return 'Falha';
      return this.testOk ? 'Sucesso' : 'Testar';
    },
    btnTestColor() {
      if (this.testError) return 'error';
      return this.testOk ? 'success' : 'primary';
    },
    btnTestIcon() {
      return this.testOk ? 'mdi-check' : 'mdi-close';
    }
  },
  methods: {
    async testServidor() {
      this.loading = true;
      this.testOk = false;
      this.testError = false;
      this.error = '';

      try {
        const response = await testApiV1Service.getConnection();
        console.log(response);
        this.loading = false;
        this.testOk = true;
      } catch (error) {
        console.log(error.message);
        this.loading = false;
        this.testOk = false;
        this.testError = true;
        this.error = error.message;
      }
    },
    save() {
      const configColetor = {
        host: this.host.trim(),
        sqlSaida: this.sqlSaida.trim(),
        sqlItemSaida: this.sqlItemSaida.trim(),
        sqlUnidades: this.sqlUnidades.trim(),
        sqlProducao: this.sqlProducao.trim(),
        sqlItemProducao: this.sqlItemProducao.trim(),
        idEstoqueEntradaProducao: this.idEstoqueEntradaProducao.trim(),
        idColaborador: this.idColaborador.trim(),
        configuracoes: this.configuracoes,
        configLayout: this.configLayout
      };

      this.$store.dispatch('saveConfiguracoes', configColetor);
      // Após salvar as configurações a página é atualizada de forma bruta
      // para que a URL do host seja registrada como URL do axios
      this.$router.go();
      this.$store.commit('SHOW_SNACKBAR', { text: 'Configurações salvas com sucesso!', status: 'success' });
    },
    async deleteDb() {
      if (confirm('Tem certeza que deseja excluir o banco de dados local?')) {
        await idbService.destroyDb();
        this.$router.go();
        this.$store.commit('SHOW_SNACKBAR', { text: 'Banco de dados local excluído com sucesso!', status: 'success' });
      }
    }
  }
}
</script>

<style>

</style>